import { Card } from '@pwskills/rachnaui';
import React from 'react';
import { companyImage } from '@/utils/common/env.constants';

type Props = {
  company: { companyLogoFileName: string; _id: string; name: string };
};

const MentorCompanyCard = ({ company }: Props) => {
  const { _id, companyLogoFileName, name } = company;

  return (
    <Card
      className="p-[6px] bg-white shadow-light rounded-2xl shrink-0  w-[218px] medium:!w-[285px] !m-0"
      key={_id}
    >
      <div className="h-[80px] medium:h-[96px] flex justify-center">
        <img
          src={`${companyImage}/company_logos/${companyLogoFileName}`}
          alt={name}
          className="w-auto h-auto"
          width={210}
          height={96}
        />
      </div>
    </Card>
  );
};

export default MentorCompanyCard;
